import PouchDB from 'pouchdb-browser';
import { DB_NAME } from './configDB';

const db = new PouchDB(DB_NAME);

export function getVideoURL(name) {
  return db
    .get(name)
    .then(() => {
      return db.getAttachment(name, name);
    })
    .then((attachment) => {
      console.log('attachment', attachment);
      return URL.createObjectURL(attachment);
    })
    .catch((error) => {
      console.log('Error getVideoURL:', error);
    });
}
export function getAudioURL(name) {
  return db
    .get(name)
    .then(() => {
      return db.getAttachment(name, name);
    })
    .then((attachment) => {
      console.log('attachment', attachment);
      return URL.createObjectURL(attachment);
    })
    .catch((error) => {
      console.log('Error getAudioURL:', error);
    });
}

/** first test with one film */
// db.get('test.mp4')
//   .then((doc) => {
//     return;
//   })
//   .catch((error) => {
//     return video().then((video) => {
//       return db.put({
//         _id: name,
//         _attachments: {
//           [name]: {
//             content_type: 'video/mp4',
//             data: video,
//           },
//         },
//       });
//     });
//   })
//   .then(() => {
//     return db.get(name);
//   })
//   .then((doc) => {
//     console.log('doc', doc);
//     return db.get(name);
//   })
//   .then(() => {
//     return db.getAttachment(name, name);
//   })
//   .then((last) => {
//     console.log('last', last);
//     return URL.createObjectURL(last);
//   })
//   .then((url) => {
//     console.log('url', url);
//     // let video = document.getElementsByTagName('video');
//     // console.log('video', video);
//     this.videoFile = url;
//   })
//   .catch((error) => {
//     console.log('Error:', error);
//   });
